import type { ComposeTab } from '../composeActions';

/**
 * Platform navigation — cross-system surface links. kind:'navigate'
 * dispatches via react-router-dom useNavigate.
 *
 * Growth slot per spec §2.5: ships near-empty (2 entries — Forge,
 * Gymnasium); promote when more cross-system surfaces land
 * (Artifactory, Pulse, others).
 *
 * Note: Forge route requires personaId at runtime — ComposePanel's
 * dispatch wrapper appends `?personaId=...` when route is
 * '/personas/forge'. Static placeholder here.
 */
export const platformTab: ComposeTab = {
  id: 'platform',
  emoji: '🛠',
  label: 'Platform',
  descriptor: 'Cross-system surfaces — Forge, Gymnasium, more soon',
  actions: [
    {
      kind: 'navigate',
      id: 'platform-forge',
      label: '🛠 Open in Forge',
      descriptor: 'Edit persona in the Forge',
      route: '/personas/forge',
    },
    {
      kind: 'navigate',
      id: 'platform-gymnasium',
      label: '🏆 Test in Gymnasium',
      descriptor: 'Open the Arena',
      route: '/gymnasium/arena',
    },
  ],
};
